const routes=[
  {
    path:"/contactAuthor",
    meta:{
      tag:"联系作者"
    },
    component:()=>import("../views/feedback/ContactAuthor.vue")
  }
]
export default routes;